import { render, staticRenderFns } from "./EntityGroup.vue?vue&type=template&id=25d29d7a"
import script from "./EntityGroup.vue?vue&type=script&lang=js"
export * from "./EntityGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports